var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.actionInProgress,
          expression: "actionInProgress"
        }
      ],
      staticClass: "well fs-3 cart-item",
      class: { "cart-item-done": _vm.isCartCanceled || _vm.isCartPaid }
    },
    [
      _c("div", { staticClass: "flex-level" }, [
        _c("h3", { staticClass: "m-0" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$filters.capitalize(
                  _vm.$l10n.__("panier %(context)s", {
                    context: _vm.$filters.capitalize(_vm.cart.context)
                  })
                )
              ) +
              "\n            " +
              _vm._s(
                _vm.cart.context.includes("renew") && !!_vm.cart.earlyRenewal
                  ? _vm.$l10n.__("anticipé")
                  : ""
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "mt-1 ml-2 gray-80 semibold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("modifié")) +
              " " +
              _vm._s(_vm.formatDate(_vm.cart.updatedAt, true, true)) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            class:
              "flex-right semibold label label-" +
              _vm.getCartStatusData(_vm.cartStatus).css
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$filters.capitalize(
                    _vm.getCartStatusData(_vm.cartStatus).label
                  )
                ) +
                "\n            " +
                _vm._s(
                  _vm.isCartExpired ? " (" + _vm.$l10n.__("expiré") + ")" : ""
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _vm.cartActions.length > 0
          ? _c(
              "div",
              [
                _c("dropdown-multi-level", {
                  attrs: {
                    actions: _vm.cartActions,
                    permissions: _vm.permissions
                  },
                  on: { clicked: _vm.switchAction }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 7 } }, [
            _c(
              "div",
              { staticClass: "pr-3 mr-3 br-2" },
              [
                _c("h4", { staticClass: "my-2 semibold" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$filters.capitalize(_vm.$l10n.__("informations"))
                      ) +
                      ":\n                "
                  )
                ]),
                _vm._v(" "),
                _c("line-2-slots", {
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("source"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(_vm.$filters.capitalize(_vm.cart.source))
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _vm.cart.source == "sales"
                  ? _c("line-2-slots", {
                      staticClass: "mb-2",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.$l10n.__("commercial")
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.cart.ownerFirstName +
                                        " " +
                                        _vm.cart.ownerName
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2964373596
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("line-2-slots", {
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("pricing"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            "v." +
                              _vm._s(_vm.cart.pricingVersion) +
                              " (rev.\n                        " +
                              _vm._s(_vm.cart.pricingVersionRevision) +
                              ")"
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("line-2-slots", {
                  staticClass: "mb-2",
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("plan"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [_vm._v(_vm._s(_vm.cart.pricingPlanId))]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("line-2-slots", {
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("créé le"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.formatDate(_vm.cart.createdAt, true, true)
                              ) +
                              "\n                    "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                !_vm.isCartValidating && !_vm.isCartValidated && !_vm.isCartPaid
                  ? _c("line-2-slots", {
                      attrs: { isSubtitle: _vm.isCartExpired },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.$l10n.__("expire le")
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm.isCartExpired
                                  ? _c("i", { staticClass: "chip chip-error" })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.formatDate(_vm.cart.expirationDate)
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        776783506
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.cart.periodApplianceStart
                  ? _c("line-2-slots", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.$l10n.__("début d'application")
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.cart.periodApplianceStart
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        60836533
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.cart.periodApplianceStop
                  ? _c("line-2-slots", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.capitalize(
                                        _vm.$l10n.__("fin d'application")
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatDate(_vm.cart.periodApplianceStop)
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3880798530
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 10 } }, [
            _c("div", { staticClass: "pr-3 mr-3 br-2" }, [
              _c("h4", { staticClass: "my-2 semibold" }, [
                _vm._v(
                  _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("contenu"))) + ":"
                )
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "m-0" },
                _vm._l(_vm.itemsOrdered, function(item) {
                  return _c("li", { key: item.id, staticClass: "flex-level" }, [
                    _c("span", { staticClass: "flex-1" }, [
                      _vm._v(_vm._s(_vm.product(item.product).printableName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "flex-item-right flex-2 px-2" }, [
                      _vm.productPlan(item.product).licensed
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "label label-danger p-1 fs-2 semibold"
                            },
                            [_vm._v("x" + _vm._s(item.quantity))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.productPlan(item.product).licensed &&
                      _vm.itemFreePricingTier(item)
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "label label-success p-1 fs-2 semibold"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "dont %(offered)s offert",
                                    "dont %(offered)s offerts",
                                    _vm.itemFreePricingTier(item),
                                    { offered: _vm.itemFreePricingTier(item) }
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    !_vm.itemHasPricingTier(item) &&
                    _vm.amountPerMonth(item, true) !== _vm.amountPerMonth(item)
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "flex-item-right flex-1 aright strike gray-60 mr-1"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.numberFormatWithOptions(
                                  _vm.amountPerMonth(item),
                                  { precision: 2 },
                                  true
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.itemHasPricingTier(item)
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "flex-item-right flex-1 aright semibold"
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$filters.numberFormatWithOptions(
                                    _vm.amountPerMonth(item, true),
                                    { precision: 2 },
                                    true
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      : _c(
                          "ul",
                          { staticClass: "aright bb-1" },
                          [
                            _vm._l(_vm.itemPricingTier(item), function(tier) {
                              return _c("li", { key: tier.up_to }, [
                                tier.unit_amount == 0
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$l10n.n__(
                                              "%(users)s utilisateur offert",
                                              "%(users)s utilisateurs offerts",
                                              tier.qty,
                                              { users: tier.qty }
                                            )
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : tier.up_to !== "inf"
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$l10n.n__(
                                              "%(users)s utilisateur :",
                                              "%(users)s utilisateurs :",
                                              tier.qty,
                                              { users: tier.qty }
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                      _vm.currencyAmount(tier.unit_amount) !==
                                      _vm.amountPerMonth(item)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "strike gray-60 mr-1"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$filters.numberFormatWithOptions(
                                                      _vm.amountPerMonth(item),
                                                      { precision: 2 },
                                                      true
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$filters.numberFormatWithOptions(
                                              _vm.currencyAmount(
                                                tier.unit_amount
                                              ),
                                              { precision: 2 },
                                              true
                                            )
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$l10n.n__(
                                              "%(users)s utilisateur :",
                                              "%(users)s utilisateurs :",
                                              item.quantity - tier.from,
                                              {
                                                users: item.quantity - tier.from
                                              }
                                            )
                                          ) +
                                          "\n                                    "
                                      ),
                                      _vm.currencyAmount(tier.unit_amount) !==
                                      _vm.amountPerMonth(item)
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "strike gray-60 mr-1"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.numberFormatWithOptions(
                                                    _vm.amountPerMonth(item),
                                                    { precision: 2 },
                                                    true
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.$filters.numberFormatWithOptions(
                                              _vm.currencyAmount(
                                                tier.unit_amount
                                              ),
                                              { precision: 2 },
                                              true
                                            )
                                          ) +
                                          "\n                                "
                                      )
                                    ])
                              ])
                            }),
                            _vm._v(" "),
                            _vm.productPlan(item.product).licensed
                              ? _c("li", { staticClass: "semibold" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$l10n.__("Total")) +
                                      ":\n                                "
                                  ),
                                  item.quantity * _vm.amountPerMonth(item) !==
                                  _vm.currencyAmount(item.totalAmount)
                                    ? _c(
                                        "span",
                                        { staticClass: "grey strike mr-1" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$filters.numberFormatWithOptions(
                                                  item.quantity *
                                                    _vm.amountPerMonth(item),
                                                  { precision: 2 },
                                                  true
                                                )
                                              ) +
                                              "\n                                "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$filters.numberFormatWithOptions(
                                          _vm.currencyAmount(item.totalAmount),
                                          { precision: 2 },
                                          true
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 7 } }, [
            _c(
              "div",
              [
                _c("h4", { staticClass: "my-2 semibold" }, [
                  _vm._v(
                    _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("totaux HT"))) +
                      ":"
                  )
                ]),
                _vm._v(" "),
                _c("line-2-slots", {
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("par an"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$filters.numberFormat(
                                  _vm.cart.totalAmountPerYear / 100,
                                  true
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _c("line-2-slots", {
                  scopedSlots: _vm._u([
                    {
                      key: "left",
                      fn: function() {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.capitalize(_vm.$l10n.__("par mois"))
                            )
                          )
                        ]
                      },
                      proxy: true
                    },
                    {
                      key: "right",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$filters.numberFormat(
                                  _vm.cart.totalAmountPerMonth / 100,
                                  true
                                )
                              ) +
                              "\n                    "
                          )
                        ]
                      },
                      proxy: true
                    }
                  ])
                }),
                _vm._v(" "),
                _vm.isPaymentFacilityEnabled
                  ? _c("line-2-slots", {
                      staticClass: "mt-2",
                      attrs: { isSubtitle: true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Paiement en %s fois activé",
                                        _vm.cartNbFacilities
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          },
                          _vm.cartNextAmountFacility <
                          _vm.cartFirstAmountFacility
                            ? {
                                key: "right",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n                        1 x " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.cartFirstAmountFacility,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            : {
                                key: "right",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.cartNbFacilities) +
                                        " x\n                        " +
                                        _vm._s(
                                          _vm.$filters.numberFormat(
                                            _vm.cartFirstAmountFacility,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPaymentFacilityEnabled &&
                _vm.cartNextAmountFacility < _vm.cartFirstAmountFacility
                  ? _c("line-2-slots", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.cartNbFacilities - 1) +
                                    " x\n                        " +
                                    _vm._s(
                                      _vm.$filters.numberFormat(
                                        _vm.cartNextAmountFacility,
                                        true
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3941895304
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCustomPaymentFacilityEnabled
                  ? _c("line-2-slots", {
                      staticClass: "mt-2",
                      attrs: { isSubtitle: true },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Paiement en %s fois activé",
                                        _vm.cartNbFacilities
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          },
                          _vm.cartFirstAmountCustomFacility <
                          _vm.cartLastAmountCustomFacility
                            ? {
                                key: "right",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.cartNbFirstCustomFacilities
                                        ) +
                                        " x\n                        " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.cartFirstAmountCustomFacility,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            : {
                                key: "right",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.cartNbCustomFacilities) +
                                        " x\n                        " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.cartFirstAmountFacility,
                                            true
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                },
                                proxy: true
                              }
                        ],
                        null,
                        true
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCustomPaymentFacilityEnabled &&
                _vm.cartFirstAmountCustomFacility <
                  _vm.cartLastAmountCustomFacility
                  ? _c("line-2-slots", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n                        1 x " +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.cartLastAmountCustomFacility,
                                        true
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        225178393
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.cart.paymentMethod
                  ? _c("line-2-slots", {
                      staticClass: "mt-2",
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "left",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.$l10n.__("paiement")
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "right",
                            fn: function() {
                              return [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.paymentMethodsOptions.find(function(
                                        method
                                      ) {
                                        return (
                                          method.value == _vm.cart.paymentMethod
                                        )
                                      }).label
                                    )
                                  )
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1826426713
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.canShowCheckoutUrl
        ? _c(
            "div",
            { staticClass: "flex-level pt-3" },
            [
              _c("h4", { staticClass: "m-0" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Lien de paiement :")))
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "flex mx-3",
                  attrs: {
                    href: _vm.currentCheckoutUrlForCustomer,
                    target: "_blank"
                  }
                },
                [
                  _c("text-input", {
                    attrs: {
                      mode: "edit",
                      value: _vm.currentCheckoutUrlForCustomer,
                      readonly: true
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassButton",
                {
                  attrs: { type: "secondary" },
                  on: {
                    click: function($event) {
                      return _vm.handleCopyToClipboardWithToast(
                        _vm.currentCheckoutUrlForCustomer
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$l10n.__("Copier")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }